import React from 'react'

type Props = {
  children?: React.ReactNode
  showDivider?: boolean
}

export default function MegaMenuContent({ children, showDivider = true }: Props) {
  return (
    <div className='flex flex-row flex-1'>
      {showDivider && <VerticalDivider />}
      {children}
    </div>
  )
}

function VerticalDivider() {
  return <div className='bg-white self-stretch mr-7' style={{ width: '0.5px' }}></div>
}
